import React from 'react';
import { Flex } from 'antd';
import { CloseOutlined } from '@ant-design/icons';
import { Button } from '@bettercomp/ui-components';

import { ClipboardCheckIcon } from './ClipboardCheckIcon';
import cn from './styles.module.scss';

type InProgressBannerProps = {
  planName: string;
  onContinue?: () => void;
  onClose?: () => void;
};

export function InProgressBanner({ planName, onContinue, onClose }: InProgressBannerProps) {
  return (
    <Flex align="center" gap="middle" className={cn.compactContent}>
      <div className={cn.compactIcon}>
        <ClipboardCheckIcon size={22} />
      </div>
      <Flex vertical gap={2} className={cn.compactBody}>
        <Flex align="center" gap={10}>
          <span className={cn.planName}>{planName}</span>
          <span className={cn.draftBadge} data-testid="surveySeasonDraftBadge">
            <span className={cn.draftDot} />
            DRAFT
          </span>
        </Flex>
        <p className={cn.compactDescription}>Pick up where you left off and roll into the new season.</p>
      </Flex>
      <Flex align="center" gap={8}>
        <Button
          type="primary"
          size="large"
          onClick={onContinue}
          data-testid="surveySeasonContinueButton"
          className={cn.ctaButton}
        >
          Continue
        </Button>
        {onClose && (
          <Button
            type="text"
            icon={<CloseOutlined />}
            onClick={onClose}
            data-testid="surveySeasonCloseButton"
            aria-label="Dismiss"
            className={cn.closeButton}
          />
        )}
      </Flex>
    </Flex>
  );
}
